'use client';

import React, { useState } from 'react';

const specialties = ['All Specialties', 'RN', 'CNA', 'LPN', 'NP', 'MD'];
const facilities = ['All Facilities', 'Riverside Medical', "St. Luke\'s North", 'Oakwood Community', 'Valley Health', 'Memorial East'];
const views = ['Week', 'Day', 'List'];

export default function SchedulingFilters() {
  const [specialty, setSpecialty] = useState('All Specialties');
  const [facility, setFacility] = useState('All Facilities');
  const [view, setView] = useState('Week');

  return (
    <div className="flex flex-wrap items-center gap-3">
      <select
        value={specialty}
        onChange={(e) => setSpecialty(e?.target?.value)}
        className="pl-3 pr-7 py-2 text-sm bg-card border border-border rounded-lg focus:border-primary focus:outline-none appearance-none cursor-pointer"
      >
        {specialties?.map((s) => (
          <option key={`spec-${s}`} value={s}>{s}</option>
        ))}
      </select>
      <select
        value={facility}
        onChange={(e) => setFacility(e?.target?.value)}
        className="pl-3 pr-7 py-2 text-sm bg-card border border-border rounded-lg focus:border-primary focus:outline-none appearance-none cursor-pointer"
      >
        {facilities?.map((f) => (
          <option key={`fac-${f}`} value={f}>{f}</option>
        ))}
      </select>
      <div className="ml-auto flex items-center gap-1 bg-muted rounded-lg p-1">
        {views?.map((v) => (
          <button
            key={`view-${v}`}
            onClick={() => setView(v)}
            className={`px-3 py-1.5 text-xs font-500 rounded-md transition-colors ${
              view === v ? 'bg-card shadow-sm text-foreground' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {v}
          </button>
        ))}
      </div>
      {/* Legend */}
      <div className="flex items-center gap-3 ml-2">
        {[
          { label: 'RN', cls: 'badge-rn' },
          { label: 'CNA', cls: 'badge-cna' },
          { label: 'LPN', cls: 'badge-lpn' },
          { label: 'NP', cls: 'badge-np' },
        ]?.map((item) => (
          <div key={`leg-${item?.label}`} className="flex items-center gap-1.5">
            <span className={`w-2.5 h-2.5 rounded-sm ${item?.cls}`} />
            <span className="text-[11px] text-muted-foreground">{item?.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}